export default __webpack_public_path__ + "static/media/DailyRoutine_15.78964134.png";